/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "db49ecc6dea5f0c48ecf029180ededfd37c20bdf";
